<template>

  <div
    class="questionnaire-text"
    v-html="description">
  </div>

</template>

<script>
export default {
  name: 'QuestionnaireDescription',
  components: {
  },
  props: {
    description: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .questionnaire-text{

  }
    .questionnaire-text h2{
      font-size: 1.3rem;
    }
    .questionnaire-text h3{
      font-size: 1.1rem;
      font-weight: bold;
    }
    .questionnaire-text ul{
      margin-bottom: 1.3rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Questionnaire/QuestionnaireDescription.vue